import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import CodeGroup from "./CodeGroup";
import Groups from "./groups";

interface IProps {}

const Cheatsheet: React.FC<IProps> = () => {
  return (
    <>
      <Helmet>
        <title>Cheatsheet • Beam</title>
      </Helmet>
      <Container>
        <CodeGroup codeBlocks={Groups[0].codeBlocks} title={Groups[0].title} />
        <SectionSplit />
        <CodeGroup codeBlocks={Groups[1].codeBlocks} title={Groups[1].title} />
      </Container>
    </>
  );
};

export default Cheatsheet;

const Container = styled.div`
  max-width: 1000px;
  margin: 64px auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

const SectionSplit = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.colors.gray7};
  margin: 48px 0;
`;
